import { ChangeEvent, FocusEvent } from 'react'
import { useSetRecoilState } from 'recoil'

import { RefundAccount, RefundName } from '@/features/support/refund/store'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import {
  CertNumState,
  InquiryEmail,
  InquiryName,
  InquiryPhoneNum,
  InquiryTitle,
  SecurityNumState,
  TelNumState,
} from '@/shared/store'
import { validInputLength } from '@/shared/utils'

export const LangRegExp = /[^ㄱ-ㅎ|ㅏ-ㅣ|가-힣||a-zA-Z]/g
export const ExcepkorRegExp = /[^0-9||a-zA-Z||@,._-]/g
export const NumRegExp = /[^0-9]/gi
export const EmailRegExp =
  /([\w-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/

const useValid = () => {
  const setTelNum = useSetRecoilState(TelNumState)
  const setCertNum = useSetRecoilState(CertNumState)
  const setSecurityNum = useSetRecoilState(SecurityNumState)
  const setInquiryName = useSetRecoilState(InquiryName)
  const setInquiryTelNum = useSetRecoilState(InquiryPhoneNum)
  const setInquiryEmail = useSetRecoilState(InquiryEmail)
  const setInquiryTitle = useSetRecoilState(InquiryTitle)
  const setRefundName = useSetRecoilState(RefundName)
  const setRefundAccount = useSetRecoilState(RefundAccount)
  const { width } = useWindowDimensions()
  const PhoneNumValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      if (width > 360) {
        setTelNum([
          {
            state: '010' + e.target.value,
            check: e.target.value.length > 7 && true,
          },
        ])
      } else {
        setTelNum([
          {
            state: e.target.value,
            check: e.target.value.length > 10 && true,
          },
        ])
      }
    }
  }
  const CertNumValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      setCertNum(e.target.value)
    }
  }
  const SecurityValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      setSecurityNum(e.target.value)
    }
  }
  const InquiryNameValid = (e: ChangeEvent<HTMLInputElement>) => {
    setInquiryName([
      {
        state: e.target.value,
        check: e.target.value.length > 1 && true,
      },
    ])
  }
  const InquiryPhoneNumValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replaceAll(NumRegExp, '')
    } else {
      setInquiryTelNum([
        {
          state: e.target.value,
          check: e.target.value.length > 10 && true,
        },
      ])
    }
  }
  const InquiryEmailValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 30) {
      e.target.value = e.target.value.slice(0, -1)
    }
    if (ExcepkorRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replace(ExcepkorRegExp, '')
    } else {
      if (EmailRegExp.test(e.target.value)) {
        setInquiryEmail([
          {
            state: e.target.value,
            check: EmailRegExp.test(e.target.value) && true,
          },
        ])
      } else {
        setInquiryEmail([
          {
            state: e.target.value,
            check: false,
          },
        ])
      }
    }
  }
  const InquiryTitleValid = (e: ChangeEvent<HTMLInputElement>) => {
    setInquiryTitle([
      {
        state: e.target.value,
        check: e.target.value.length > 1 && true,
      },
    ])
  }

  const RefundNameValid = (e: ChangeEvent<HTMLInputElement>) => {
    setRefundName([
      {
        state: e.target.value,
        check: e.target.value.length > 1 && true,
      },
    ])
  }
  const RefundAccountValid = (e: ChangeEvent<HTMLInputElement>) => {
    if (NumRegExp.test(e.target.value)) {
      e.target.value = e.target.value.replace(NumRegExp, '')
    } else
      setRefundAccount([
        {
          state: e.target.value,
          check: e.target.value.length > 7 && true,
        },
      ])
  }

  const onBlurForValidationCert = (e: FocusEvent<HTMLInputElement>) =>
    validInputLength(e.target.value, 4)
  const onBlurForValidationAccount = (e: FocusEvent<HTMLInputElement>) =>
    validInputLength(e.target.value, 8)

  const onBlurForValidationString = (e: FocusEvent<HTMLInputElement>) =>
    validInputLength(e.target.value, 2) || LangRegExp.test(e.target.value)

  return {
    PhoneNumValid,
    CertNumValid,
    SecurityValid,
    InquiryNameValid,
    InquiryPhoneNumValid,
    InquiryEmailValid,
    InquiryTitleValid,
    RefundNameValid,
    RefundAccountValid,
    onBlurForValidationCert,
    onBlurForValidationAccount,
    onBlurForValidationString,
  }
}

export default useValid
